<template>
  <div>
    <add-project></add-project>
  </div>
</template>

<script>
import AddProject from './AddProject.vue';

export default {
  components: {
    AddProject,
  },

  data() {
    return {};
  },
};
</script>
